import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

const sitePageImage = '/images/sitePage.png';

const Home = () => {
  const heroStyle = {
    backgroundImage: `url(${sitePageImage})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat'
  };

  const productCategories = [
    {
      id: 'support',
      name: '液压支架',
      image: '/images/sy-1.jpg',
      description: '矿用成套综采液压支架，质量可靠，性能优越'
    },
    {
      id: 'cylinder',
      name: '液压油缸',
      image: '/images/sy-2.jpg',
      description: '包括千斤顶、立柱，承载能力强，运行平稳可靠'
    },
    {
      id: 'hose',
      name: '高压胶管',
      image: '/images/sy-3.jpg',
      description: '高品质高压胶管，耐高压，耐腐蚀，安全可靠'
    }
  ];

  // 合作伙伴数据
  const partners = [
    { id: 1, name: '中国煤炭工业协会', logo: '/images/partner-1.png' },
    { id: 2, name: '国家能源集团', logo: '/images/partner-2.png' },
    { id: 3, name: '中煤能源集团', logo: '/images/partner-3.png' },
    { id: 4, name: '潞安化工集团', logo: '/images/partner-4.png' },
    { id: 5, name: '山西焦煤集团', logo: '/images/partner-5.png' },
    { id: 6, name: '龙煤矿业控股集团', logo: '/images/partner-6.png' },
    { id: 7, name: '青山控股集团', logo: '/images/partner-7.svg' },
    { id: 8, name: '晋能控股集团', logo: '/images/partner-8.png' }
  ];

  return (
    <>
      {/* Hero 区域 */}
      <section className="hero" style={heroStyle}>
        <div className="hero-overlay"></div>
      </section>

      {/* 公司简介 */}
      <section className="about-section section">
        <div className="container">
          <div className="about-content">
            <div className="about-text">
              <h3>公司简介</h3>
              <p>巨隆液压设备（集团）有限公司主要从事矿用成套综采液压支架，液压支架的立柱、千斤顶、各类控制阀及高压胶管等配件的研究，开发与制造。生产历史三十多年，是国内较早生产煤矿综采设备生产的厂家之一，是国内第一批荣获国家原煤炭工业部定点生产单位。</p>
            </div>
            <div className="about-image">
              <div className="about-stats">
                <div className="stat-item">
                  <div className="stat-number">30+</div>
                  <div className="stat-label">行业经验</div>
                </div>
                <div className="stat-item">
                  <div className="stat-number">500+</div>
                  <div className="stat-label">客户企业</div>
                </div>
                <div className="stat-item">
                  <div className="stat-number">1000+</div>
                  <div className="stat-label">成功案例</div>
                </div>
                <div className="stat-item">
                  <div className="stat-number">98%</div>
                  <div className="stat-label">客户满意度</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 产品展示 */}
      <section className="products-section section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">产品中心</h2>
            <div className="section-line"></div>
          </div>
           <div className="product-grid">
              {productCategories.map(category => (
                <Link 
                  to={`/products?category=${category.id}`} 
                  key={category.id} 
                  className="product-card"
                >
                  <div className="product-image">
                    <img src={category.image} alt={category.name} />
                  </div>
                  <div className="product-info">
                    <h3>{category.name}</h3>
                    <p>{category.description}</p>
                  </div>
                </Link>
              ))}
            </div>
         </div>
      </section>

      {/* 合作伙伴展示 */}
      <section className="partners-section section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">合作伙伴</h2>
            <div className="section-line"></div>
          </div>
           <div className="partners-grid">
             {partners.map((partner, index) => (
               <div key={partner.id} className="partner-card">
                 <div className="partner-logo">
                   <img 
                     src={partner.logo} 
                     alt={partner.name}
                     onError={(e) => {
                       e.target.style.display = 'none';
                       e.target.parentNode.classList.add('no-image');
                     }}
                   />
                 </div>
                 <div className="partner-name">{partner.name}</div>
               </div>
             ))}
           </div>
        </div>
      </section>
    </>
  );
};

export default Home;
